import { snackBarError } from '#action/fetch';
import { webPortalApi } from '#config/web-portal-api';
import {
  SUCCESS
} from '#action/types';
import { updateApplianceEvents } from './appliance-devices';
import { getRequestOptions } from '#helper';

export const patchApplianceAlertAcceptance = (applianceId, item, acceptance) => async dispatch => {
  try {
    const logId = item?.details?.logId;
    const res = await fetch(webPortalApi.buildApiUrl(`warehouse/appliance/${applianceId}/accept-alert/${logId}`), {
      method: 'PATCH',
      body: JSON.stringify(acceptance),
      ...getRequestOptions()
    });

    if (!res.ok) {
      throw await res.json();
    }

    dispatch(updateApplianceEvents({ newEvent: item, acceptance }));

    dispatch({
      type: SUCCESS,
      payload: {
        message: 'Alert has been accepted'
      }
    });

    return { success: true };
  } catch (e) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...e
    }));
    return { success: false };
  }
};

export const deleteApplianceAlertAcceptance = (applianceId, item) => async dispatch => {
  try {
    const logId = item?.details?.logId;
    const url = webPortalApi.buildApiUrl(`warehouse/appliance/${applianceId}/accept-alert/${logId}`);
    const res = await fetch(url, {
      method: 'DELETE',
      ...getRequestOptions()
    });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    if (!res.ok) {
      throw await res.json();
    }

    dispatch(updateApplianceEvents({ newEvent: item }));

    dispatch({
      type: SUCCESS,
      payload: {
        message: 'Acceptance has been deleted'
      }
    });

    return await res.json();
  } catch (e) {
    dispatch(snackBarError({
      message: 'Error in request',
      ...e
    }));
    return { success: false };
  }
};
